import { Component } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { routes } from '../../../app-routing.module';
import { Title } from '@angular/platform-browser';
import { AuthService } from 'src/app/auth/auth.service';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    standalone: false
})
export class NavigationComponent {

  private readonly hiddenMenuPaths = ['vocabularies'];

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  routes = routes.filter(route => !this.hiddenMenuPaths.includes(route.path ?? ''));

  constructor(
    public titleService: Title,
    private breakpointObserver: BreakpointObserver,
    private authService: AuthService) {
  }

  logout(){
    this.authService.logout()
  }
}
